import aboBtn from '../../images/docs/main-menu-abo-edit.png';
import newAbo from '../../images/docs/abo-edit.png';
import confirmBuy from '../../images/docs/confirm-buy-edit.png';
import payments from '../../images/docs/main-menu-pay-edit.png';
import paymentElement from '../../images/docs/payment-history-edit.png';

export const meta = {
  slug: 'abonamente',
  title: 'Abonamente',
  description: 'Verificarea, crearea și activarea abonamentelor pe platforma Programintrastat.ro.',
  icon: 'star',
  order: 4,
  related: ['facturi-si-plati', 'cont'],
};

export const images = { aboBtn, newAbo, confirmBuy, payments, paymentElement };

export const content = `
## Abonamente

Pentru a verifica orice informație legată de abonamente trebuie să fiți autentificat.

### 1. Verificare abonament

Intrați în meniul "Abonamente" <span class="dot">1</span>, iar acolo veți putea verifica toate informațiile legate de abonamentele anterioare și de cel actual.

::image[aboBtn]{alt="Butonul principal abonamente"}

Puteți vizualiza date precum linii de generare rămase din lună, dar și perioada de valabilitate a abonamentului actual.

### 2. Creare abonament

Un abonament DEMO este creat automat odată cu crearea contului. Acesta are o valabilitate prestabilită care poate fi verificată din secțiunea "Abonamente". Pentru mai multe detalii verificați subcapitolul anterior. Pentru crearea unui abonament nou trebuie întâi accesată pagina "Abonamente" <span class="dot">1</span>

::image[aboBtn]{alt="Butonul principal abonamente"}

Odată ce ați ajuns pe acea pagină trebuie să dați click pe butonul "Abonament nou" <span class="dot">2</span>

::image[newAbo]{alt="Butonul abonament nou"}

Veți fi întâmpinați apoi cu o listă de abonamente împreună cu prețurile și informațiile acestora. Selectați pachetul dorit dând click pe acesta. Se va deschide o fereastră care va afișa toate detaliile pachetului selectat. La finalul acestei ferestre alegeți modalitatea de plată <span class="dot">3</span>

<p class="warn">Odată selectat abonamentul nou, cel vechi va fi dezactivat.</p>

::image[confirmBuy]{alt="Butonul achiziționează abonament"}

Aveți două opțiuni:

- **Plătește cu cardul** - veți completa datele de facturare, apoi veți fi redirecționat către pagina securizată NETOPIA Payments. Datele cardului nu trec și nu sunt stocate pe serverele noastre. După confirmarea plății, **abonamentul se activează automat**, în câteva secunde, iar factura fiscală devine imediat disponibilă în secțiunea "Plăți".
- **Plată prin transfer bancar** - se emite o factură proformă cu datele necesare plății. Abonamentul se activează **după confirmarea încasării** de către noi, de regulă în 1-2 zile lucrătoare.

În ambele cazuri comanda se înregistrează imediat, iar modalitatea de plată poate fi schimbată ulterior din secțiunea "Plăți". Pentru abonamente personalizate vă rugăm să ne contactați. Procesul activării unui abonament personalizat este diferit, iar pașii vă vor fi detaliați prin email sau telefonic dacă optați pentru unul. În cazul în care abonamentul selectat nou nu apare în lista de abonamente puteți încerca:

- Să reîncărcați pagina web.
- Să verificați dacă abonamentul anterior este valid, iar dacă este, să mai comandați încă odată abonamentul nou.
- Să vă asigurați că aveți o conexiune stabilă la internet.
- Să ne contactați.

### 3. Abonament personalizat

Pentru crearea unui abonament personalizat vă rugăm să ne contactați la adresa de email [programintrastat@gmail.com](mailto:programintrastat@gmail.com).

### 4. Activare abonament

Pentru a activa un abonament trebuie navigat în meniul "Plăți" <span class="dot">1</span>

::image[payments]{alt="Butonul principal plăți"}

În acest meniu trebuie observată cea mai recentă intrare din tabelul "Istoric plăți". Aceasta va fi marcată ca și "Proformă" <span class="dot">2</span> până în momentul achitării acesteia. Puteți vizualiza factura aferentă abonamentului nou achiziționat făcând click pe butonul de sub "Factură" <span class="dot">3</span>. Pentru a finaliza comanda prin plata facturii selectați butonul "Achită" <span class="dot">4</span> de sub meniul "Acțiuni".

::image[paymentElement]{alt="Butoanele din elementul de plată"}

Selectați modalitatea de plată dorită:

- **Plată cu cardul** - activare automată, imediat după confirmarea plății. Nu este nevoie să ne contactați.
- **Transfer bancar** - se afișează IBAN-ul, beneficiarul, suma exactă și detaliile plății. În cazul în care doriți ca activarea abonamentului să fie prioritizată de către noi, vă rugăm să ne trimiteți un email la adresa [programintrastat@gmail.com](mailto:programintrastat@gmail.com) cu dovada plății atașate. Vă vom răspunde și activa abonamentul cât de repede posibil.

Odată ce abonamentul este activat, veți putea vizualiza și descărca factura nou emisă din secțiunea "Plăți".

<p class="warn">Dacă o plată cu cardul nu reușește sau renunțați la ea, nu se reține nicio sumă. Comanda rămâne valabilă și puteți reîncerca oricând, cu cardul sau prin transfer bancar.</p>

### 5. Anulare abonament

Anularea unui abonament se poate efectua doar înainte de efectuarea plății pentru activarea acestuia.

Din secțiunea "Plăți", în dreptul comenzii neachitate, apăsați butonul "Anulează". Abonamentul neactivat va fi dezactivat, iar abonamentul anterior, dacă mai este valabil, redevine activ. După anulare puteți alege din nou orice abonament.

Dacă întâmpinați probleme, ne puteți contacta la adresa de email [programintrastat@gmail.com](mailto:programintrastat@gmail.com) cu adresa de email cu care ați creat contul.
`;
